(() => {
  if (customElements.get('msport-buy-shortcut')) return;
  customElements.define('msport-buy-shortcut', class extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      const purchase = document.getElementById(`MsportPurchase-${this.dataset.section}`);
      if (!purchase || !('IntersectionObserver' in window)) return;
      this.link = this.querySelector('a');
      this.target = document.getElementById(`MsportOptions-${this.dataset.section}`) || purchase;
      this.link.href = `#${this.target.id}`;
      this.onClick = () => this.target.focus({ preventScroll: true });
      this.link.addEventListener('click', this.onClick);
      this.observer = new IntersectionObserver(([entry]) => {
        // Show only after the buyer has scrolled past the native purchase controls.
        this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
      });
      this.observer.observe(purchase);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.link?.removeEventListener('click', this.onClick);
    }
  });
})();
